export function formatNumber(number, length = 2) {
  const value = Number(number);
  if (Number.isNaN(value)) {
    return String(number);
  }

  if (number === null) {
    return "-";
  }

  return value.toFixed(length);
}
